
export class Attribute {
    public name: string;
    public value: string;
}

export function createDiv(className?: string, innerText?: string, attributes?: Array<Attribute>): HTMLDivElement {
    let control = document.createElement("div");
    if (className) {
        control.className = className;
    }
    if (innerText) {
        control.innerText = innerText;
    }
    addAttributes(control, attributes);
    return control;
}

export function createAnchor(className?: string, innerText?: string, attributes?: Array<Attribute>): HTMLAnchorElement {
    let control = document.createElement("a");
    if (className) {
        control.className = className;
    }
    if (innerText) {
        control.innerText = innerText;
    }
    addAttributes(control, attributes);
    return control;
}

export function createLabel(className?: string, innerText?: string, attributes?: Array<Attribute>): HTMLLabelElement {
    let control = document.createElement("label");
    if (className) {
        control.className = className;
    }
    if (innerText) {
        control.innerText = innerText;
    }
    addAttributes(control, attributes);
    return control;
}

export function createButton(className: string, innerText: string = null, attributes: Array<Attribute> = null): HTMLButtonElement {
    let control = document.createElement("button");
    control.type = "button";
    control.className = className;
    if (innerText)
        control.innerText = innerText;
    addAttributes(control, attributes);
    return control;
}

export function createDropDownToggle(addClassName: string = null): HTMLDivElement {
    let control = document.createElement("div");
    control.className = "dropdown-toggle " + addClassName ? addClassName : "";
    addAttributes(control, [
        { name: "data-toggle", value: "dropdown" },
        { name: "aria-haspopup", value: "true" },
        { name: "aria-expanded", value: "false" }
    ]);
    return control;
}

export function createFontAwesome(iconName: string, addClassName: string = null, attributes: Array<Attribute> = null): HTMLElement {
    let control = document.createElement("i");
    control.className = "fa fa-" + iconName;
    if (addClassName)
        control.className += " " + addClassName;
    addAttributes(control, attributes);
    return control;
}

export function createFontAwesomeLight(iconName: string, addClassName: string = null, attributes: Array<Attribute> = null): HTMLElement {
    let control = document.createElement("i");
    control.className = "fal fa-" + iconName;
    if (addClassName)
        control.className += " " + addClassName;
    addAttributes(control, attributes);
    return control;
}

export function createSpan(className: string, attributes: Array<Attribute> = null, innerText: string = null): HTMLSpanElement {
    let control = document.createElement("span");
    control.className = className;
    addAttributes(control, attributes);
    if (innerText)
        control.innerText = innerText;
    return control;
}

export function createH4(innerText: string, addClassName: string = null): HTMLElement {
    let control = document.createElement("h4");
    control.innerText = innerText;
    if (addClassName)
        control.className = addClassName;
    return control;
}

export function createH5(innerText: string, addClassName: string = null): HTMLElement {
    let control = document.createElement("h5");
    control.innerText = innerText;
    if (addClassName)
        control.className = addClassName;
    return control;
}

export function createTable(className: string, attributes: Array<Attribute> = null): HTMLTableElement {
    let control = document.createElement("table");
    control.className = className;
    addAttributes(control, attributes);
    return control;
}

export function createTableRow(className?: string, attributes: Array<Attribute> = null): HTMLTableRowElement {
    let control = document.createElement("tr");
    if (className) {
        control.className = className;
    }
    addAttributes(control, attributes);
    return control;
}

export function createTableCell(className?: string, innertText?: string, attributes?: Array<Attribute>): HTMLTableCellElement {
    let control = document.createElement("td");
    if (className) {
        control.className = className;
    }
    if (innertText) {
        control.innerText = innertText;
    }
    addAttributes(control, attributes);
    return control;
}

export function createCheckBox(id: string, text: string, className?: string, inputClassName?: string, attributes: Array<Attribute> = null): HTMLDivElement {
    let div = document.createElement("div");
    if (className) {
        div.className = className;
    }
    div.classList.add("checkbox");

    let checkbox = createInput("checkbox", inputClassName);
    checkbox.id = id;
    addAttributes(checkbox, attributes);
    div.appendChild(checkbox);

    let label = createLabel("form-check-label", text, [{ name: "for", value: id }]);
    div.appendChild(label);

    return div;
}

export function createInput(type: string, className: string, attributes: Array<Attribute> = null, value: string = null): HTMLInputElement {
    let control = document.createElement("input");
    control.type = type;
    control.className = className;
    addAttributes(control, attributes);
    if (value)
        control.value = value;
    return control;
}

export function createOption(text: string, value: string): HTMLOptionElement {
    let control = document.createElement("option");
    control.text = text;
    control.value = value;
    return control;
}

export function createUserIcon(element: HTMLElement, userName: string, attributes: Array<Attribute> = null) {
    element.innerHTML = "<svg height='32' width='32'><circle cx='16' cy='16' r='16' stroke='1' fill='white' /></svg>"
    let text: string = "";
    if (userName && userName.length > 0) {
        let split = userName.split(" ");
        if (split && split.length > 0) {
            text = split[0][0].toUpperCase();
            if (split.length > 1) {
                text += split[1][0].toUpperCase();
            }
        }
    }
    element.innerHTML += "<span class='mso-user-text'>" + text + "</span>";
}

export function updateUserIcon(element: HTMLElement, userName: string) {
    let text: string = "";
    if (userName && userName.length > 0) {
        let split = userName.split(" ");
        if (split && split.length > 0) {
            text = split[0][0].toUpperCase();
            if (split.length > 1) {
                text += split[1][0].toUpperCase();
            }
        }
    }
    element.lastElementChild.innerHTML = text;
}

export function createLoadingPanel(): HTMLDivElement {
    let divOuter = createDiv("text-center");
    let divLoading = createDiv("mt-1 mb-1", "Loading...");
    divOuter.appendChild(divLoading);
    let divSpinner = createDiv("spinner-border mb-1");
    divOuter.appendChild(divSpinner);
    return divOuter;
}

export function addAttributes(control: HTMLElement, attributes: Array<Attribute>) {
    if (attributes) {
        for (let attr of attributes)
            control.setAttribute(attr.name, attr.value);
    }
}

export function createProgress(value: number, min: number, max: number, text: string = null, useDanger: boolean = false): HTMLDivElement {
    if (!value) {
        value = 0;
    }

    let div = createDiv("progress");
    let divProgress = createDiv("progress-bar" + (useDanger ? " bg-danger" : ""), null, [
        { name: "role", value: "progressbar" },
        { name: "aria-valuenow", value: value.toString() },
        { name: "aria-valuemin", value: min.toString() },
        { name: "aria-valuemax", value: max.toString() },
    ]);
    divProgress.style.width = value + "%";
    if (text) {
        divProgress.innerText = text;
    }
    else {
        divProgress.innerText = value + "%";
    }
    divProgress.setAttribute("aria-valuenow", value.toString());
    div.appendChild(divProgress);
    return div;
}

export function createTaskHours(worked: any, planned: any): HTMLDivElement {

    let div = createDiv("progress");
    let divProgress = createDiv("progress-bar", null, [
        { name: "role", value: "progressbar" },
        { name: "aria-valuenow", value: "0" },
        { name: "aria-valuemin", value: "0" },
        { name: "aria-valuemax", value: "100" },
    ]);
    div.appendChild(divProgress);
    updateTaskHours(divProgress, worked, planned);
    return div;
}

export function updateTaskHours(div: HTMLDivElement, worked: any, planned: any) {
    worked = parseFloat(worked);
    if (isNaN(worked))
        worked = 0;

    planned = parseFloat(planned);
    if (isNaN(planned))
        planned = 0;

    let percent: number = 0;
    if (planned > 0) {
        percent = (worked * 100) / planned;
        percent = Math.floor(percent);
        if (percent > 100)
            percent = 100;
    }
    else if (worked > 0) {
        percent = 100;
    }

    div.setAttribute("aria-valuenow", percent.toString());

    if (worked > planned) {
        div.classList.add("bg-danger");
    }
    else {
        div.classList.remove("bg-danger");
    }

    div.style.width = percent + "%";
    div.innerHTML = worked + "/" + planned;
}

export function updateProgress(element: HTMLElement, value: number) {
    if (!value) {
        value = 0;
    }
    let divProgress = <HTMLElement>element.firstElementChild;
    divProgress.style.width = value + "%";
    divProgress.innerHTML = value + "%";
    divProgress.setAttribute("aria-valuenow", value.toString());
}

export function UID(): string {
    return '_' + Math.random().toString(36).substr(2, 9);
};
